<template>
  <div
    class="answercontainer"
    :style="{ background: `url(${bgImg2}) 0 0/100% 100% no-repeat` }"
  >
    <!-- <div class="title wow bounceInDown" data-wow-duration="1s">
      <img
        :src="getImage(titleImage)"
        alt=""
        style="width: 100%;height: 100%;"
      />
    </div>-->
    <!-- <logo></logo> -->

    <div class="order wow bounceInDown" data-wow-duration="2s" :style="$store.state.themeImgs.length ? `background:url(${$store.state.themeImgs[4]}) 0 0/100% no-repeat` : ''">{{ order }}</div>

    <div class="time">{{ authTime }}s</div>

    <div class="question wow bounceInDown" data-wow-duration="2s">
      <div class="qusetion-content">{{ qusetion.question }}</div>
      <!-- <div
        class="question-image"
        v-if="
          imgList.length > 0 ||
          (imgList.length === 0 && qusetion.image !== undefined)
        "
      >
        <div
          class="oneimg"
          v-if="imgList.length === 0 && qusetion.image !== undefined"
        >
          <img
            :src="getImage(qusetion.image)"
            alt
            style="height: 100%; width: 100%"
          />
        </div>
        <div
          class="twoimg"
          v-if="imgList.length === 2"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img :src="item" alt style="height: 100%; width: 100%" />
        </div>
        <div
          class="threeimg"
          v-if="imgList.length === 3"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img :src="item" alt style="height: 100%; width: 100%" />
        </div>
        <div
          class="fourimg"
          v-if="imgList.length === 4"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img :src="item" alt style="height: 100%; width: 100%" />
        </div>
      </div> -->
    </div>
    <div class="option">
      <vuescroll :ops="ops">
        <el-radio-group
          v-model="answer"
          text-color="#a15c05"
          fill="#a15c05"
          size="mini"
          :disabled="isAnswer"
        >
          <el-radio
            label="A"
            v-if="qusetion.itemA"
            :class="{
              correct: correctAnswer === 'A' && isAnswer,
            }"
            >A &nbsp;&nbsp;&nbsp;&nbsp;{{ qusetion.itemA }}</el-radio
          >
          <el-radio
            label="B"
            v-if="qusetion.itemB"
            :class="{
              correct: correctAnswer === 'B' && isAnswer,
            }"
            >B &nbsp;&nbsp;&nbsp;&nbsp;{{ qusetion.itemB }}</el-radio
          >
          <el-radio
            label="C"
            v-if="qusetion.itemC"
            :class="{
              correct: correctAnswer === 'C' && isAnswer,
            }"
            >C &nbsp;&nbsp;&nbsp;&nbsp;{{ qusetion.itemC }}</el-radio
          >
          <el-radio
            label="D"
            v-if="qusetion.itemD"
            :class="{
              correct: correctAnswer === 'D' && isAnswer,
            }"
            >D &nbsp;&nbsp;&nbsp;&nbsp;{{ qusetion.itemD }}</el-radio
          >
          <el-radio
            label="E"
            v-if="qusetion.itemE"
            :class="{
              correct: correctAnswer === 'E' && isAnswer,
            }"
            >E &nbsp;&nbsp;&nbsp;&nbsp;{{ qusetion.itemE }}</el-radio
          >
        </el-radio-group>
      </vuescroll>
    </div>
    <div
      class="start wow bounceInUp"
      :style="{ pointerEvents: isSubmit }"
      data-wow-duration="3s"
      @click="submit"
    >
      <img
        :src="$store.state.themeImgs.length ? $store.state.themeImgs[1] : require('../../assets/images/confirm.png')"
        alt
        style="width: 100%; height: 100%"
      />
    </div>
    <!-- <div class="banner wow bounceInUp" data-wow-duration="4s">
      <img
        src="../../assets/images/logo1.png"
        alt
        style="width: 100%;height: 100%;"
      />
    </div> -->
    <!-- <div
      class="close wow bounceInUp"
      data-wow-duration="4s"
      @click="returnHome"
    >
      <img
        src="../../assets/images/close.png"
        alt
        style="width: 100%; height: 100%"
      />
    </div> -->
    <popup
      v-show="dialog"
      :status="status"
      :id="id"
      :time="totalTime"
      :order="order"
      :lastQuestion="lastQuestion"
      :rank="rank"
    ></popup>
    <svg height="0" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="change">
          <feColorMatrix
            values="0 0 0 0 0.63
                     0 0 0 0 0.36
                     0 0 0 0 0.02
                     0 0 0 1 0"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
import popup from "@/components/popup";
import vuescroll from "vuescroll";
import logo from "@/components/logo";
import backgroundImg from "@/assets/images/bg1.jpg";
var authTime

export default {
  name: "answer",
  components: {
    popup,
    vuescroll,
    logo,
  },
  data() {
    return {
      order: 1, // 当前关卡
      authTime: 0 /* 倒计时 计数器 */,
      backTime: 0, // 无操作返回时间
      questionList: [], // 题目列表
      imgList: [], // 题目图片
      qusetion: "", // 当前题目
      answer: "", // 所选答案
      dialog: false, // 是否弹窗
      status: "",
      wordList: [], // 文字列表
      id: this.$route.params.id, // 游戏id
      totalTime: 0, // 小游戏所用的总时间
      lastQuestion: false, // 是否是最后一题
      titleImage: "", // 游戏标题图片
      isAnswer: false, //是否显示答案
      correctAnswer: "", //正确答案
      ops: {
        vuescroll: {
          mode: "native",
          sizeStrategy: "percent",
          detectResize: true,
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: false,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: "right",
          maxHeight: undefined,
          maxWidth: undefined,
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: false,
          keepShow: true,
          background: "#c1c1c1",
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: false,
          size: "2px",
          disable: false,
        },
        rail: {
          background: "#01a99a",
          opacity: 0,
          size: "6px",
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: "0",
          keepShow: false,
        },
      },
      rank: null,
      isSubmit: "auto",
      canHandelButton: true,
      hasSelectAnswer: false
    };
  },
  created() {
    this.titleImage = this.$route.params.titleImage;
    this.authTime = Number(sessionStorage.getItem("authTime"));
    this.backTime = Number(sessionStorage.getItem("backTime"));
  },
  mounted() {
    // new WOW().init()
    // this.order = 1
    console.log(this.$store.state.museumCode);
    console.log(this.order);
    this.$nextTick(() => {
      this.time();
      this.getQuestionList();
    });
  },
  methods: {
    selectAnswer() {
      this.hasSelectAnswer = true
    },

    returnHome() {
      this.$router.replace({ name: "home" });
    },
    time() {
      console.log("倒计时");
      authTime = setInterval(() => {
        this.authTime--;
        if (this.authTime <= 0) {
          this.authTime = 0;
        }
      }, 1000);
    },
    waitReturn() {
      const backTime = setInterval(() => {
        if (this.backTime <= 0 || this.dialog === false) {
          clearInterval(backTime);
        } else {
          this.backTime--;
        }
      }, 1000);
    },
    getImage(image) {
      return window.SITE_CONFIG.imageRootUrl + image;
    },
    // 获取问题列表
    getQuestionList() {
      this.$http({
        url: this.$http.adornUrl(
          `/api/game/front/game-detail/` + this.$store.state.id
        ),
        method: "get",
      }).then((res) => {
        // console.log(res.data.data);
        // 随机出题
        for (let i = 1; i < res.data.data.length; i++) {
          const random = Math.floor(Math.random() * (i + 1));
          [res.data.data[i], res.data.data[random]] = [
            res.data.data[random],
            res.data.data[i],
          ];
        }
        this.questionList = res.data.data;
        this.getQuestion();
      });
    },
    // 获取问题详情
    getQuestion() {
      this.imgList = []; // 清空上关图片
      this.qusetion = this.questionList[this.order - 1];
      // this.wordList = this.qusetion.itemA.split('')
      // console.log(this.qusetion.image.indexOf('|'))
      if (this.qusetion.image !== undefined) {
        if (this.qusetion.image.indexOf("|") !== -1) {
          console.log(this.qusetion.image.split("|"));
          var _this = this;
          _this.qusetion.image.split("|").forEach((item) => {
            _this.imgList.push(window.SITE_CONFIG.imageRootUrl + item);
          });
        }
      }
      console.log(
        this.imgList.length === 0 && this.qusetion.image !== undefined
      );
    },
    // 提交答案
    submit() {
      console.log(this.canHandelButton)
      if (!this.canHandelButton) return
      this.canHandelButton = false
      this.isSubmit = "none";
      if (this.answer) this.hasSelectAnswer = true
      this.$http({
        url: this.$http.adornUrl(
          `/api/game/front/game-detail/answer?gameId=${this.$store.state.id}&gameDetailId=${this.qusetion.id}&answer=${this.answer}&mobilePhone=${this.$store.state.phoneNumber}`
        ),
        method: "post",
      }).then((res) => {
        console.log(res.data);
        // this.canHandelButton = true
        if (res.data.rel) {
          this.status = "correct";
          this.rank = res.data.data || null;
          this.dialog = true;
          console.log(this.dialog);
        } else {
          console.log("回答错误");
          this.isAnswer = true;
          this.correctAnswer = res.data.data.answer;
          this.rank = res.data.data.rank;
          this.$store.state.totalCount = res.data.data.totalCount
          var _this = this;
          setTimeout(function () {
            _this.status = "error";
            _this.dialog = true;
          }, 5000);
        }
      });
    },
    // 改变关卡
    changeOrder() {
      this.order++;
      this.dialog = false;
      this.hasSelectAnswer = false
      this.canHandelButton = true
      clearInterval(authTime)
    },
    changeStatus() {
      if (this.status === "correct" && !this.lastQuestion) {
        this.status = "return";
      } else if (this.status === "return") {
        this.status = "correct";
      } else if (this.status === "correct" && this.lastQuestion) {
        this.returnHome();
      }
    },
    //  退出游戏
    windowclose() {
      var browserName = navigator.appName;
      if (browserName === "Netscape") {
        window.open("", "_self", "");
        window.close();
      } else {
        if (browserName === "Microsoft Internet Explorer") {
          window.opener = "whocares";
          window.opener = null;
          window.open("", "_top");
          window.close();
        }
      }
    },
    FormattingAnswer(val) {
      return val.replace(/\s+/g, "");
    },
  },
  watch: {
    order() {
      this.time()
      this.answer = [];
      this.status = "";
      this.isSubmit = "auto";
      this.getQuestion();
      // this.$set(this.qusetion,this.questionList[this.order - 1])
      this.authTime = Number(sessionStorage.getItem("authTime"));
      this.backTime = Number(sessionStorage.getItem("backTime"));
      console.log(this.authTime);
      if (this.order === this.questionList.length) {
        this.lastQuestion = true;
      }
    },
    authTime() {
      if (this.authTime === 0 && this.dialog === false && !this.hasSelectAnswer) {
        this.answer = null;
        this.submit();
      } else if (
        this.authTime === Number(sessionStorage.getItem("authTime")) &&
        this.dialog === true
      ) {
        this.time();
      }
    },
    dialog() {
      if (this.dialog === true) {
        this.totalTime += sessionStorage.getItem("authTime") - this.authTime;
        console.log(this.totalTime);
        this.waitReturn();
      }
    },
    backTime() {
      if (this.backTime === 0 && this.dialog === true) {
        console.log("返回首页");
        this.returnHome();
      }
    },
  },
  computed: {
    bgImg2: function () {
      return this.$store.state.bgImg2
        ? this.getImage(this.$store.state.bgImg2)
        : backgroundImg;
    },
  },
};
</script>

<style lang="scss">
$small: 375px;
$medium: 1079px;
$big: 1921px;
.answercontainer {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  // background: url("../../assets/images/bg.jpg") 0 0/100% 100% no-repeat !important;
  padding-top: 0.852rem;
  // background-color: #163f9b;
  > div {
    margin: 0 auto;
    img {
      display: block;
    }
  }
  .title {
    width: 4.407rem;
    height: 0.546rem;
    margin-top: 0.898rem;
    @media screen and (min-width: 1081px) and (max-width: $big) {
      margin-top: 2rem;
    }
  }
  .order {
    width: 3.741rem;
    height: 1.2rem;
    background: url("../../assets/images/order.png") 0 0/100% no-repeat;
    margin: 10% auto 0.8rem;
    font-size: 0.9rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1rem;
    letter-spacing: 0.074rem;
    color: #fff;
  }
  .question {
    width: 8rem;
    min-height: 1.3rem;
    margin-bottom: 0.4rem;
    .question-image {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: 4rem;
      margin: 0.5rem 0;
      // 移动端
      @media screen and (min-width: $small) and (max-width: $medium) {
        height: 2rem;
        width: 100%;
        margin: 0.5rem auto;
      }
      // 一体机
      @media screen and (min-width: $medium) and (max-width: 1081px) {
        height: 2rem;
        width: 100%;
        margin: 0.5rem auto;
      }
      // pc端
      @media screen and (min-width: 1081px) and (max-width: $big) {
        height: 3rem;
      }
      .oneimg {
        // position: absolute;
        // left: 39%;
        // top: 30%;
        width: 100%;
        height: 100%;
      }
      .twoimg {
        position: absolute;
        width: 45%;
        height: 100%;
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          right: 0;
        }
      }
      .threeimg {
        position: absolute;
        width: 30%;
        height: 100%;
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          left: 35%;
        }
        &:nth-child(3) {
          right: 0;
        }
      }
      .fourimg {
        position: absolute;
        width: 23%;
        height: 100%;
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          left: 25.6%;
        }
        &:nth-child(3) {
          right: 25.6%;
        }
        &:nth-child(4) {
          right: 0;
        }
      }
    }

    .qusetion-content {
      font-family: PingFangSC-Regular;
      font-size: 0.45rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.55rem;
      letter-spacing: 0.074rem;
      color: #fff;
      text-align: left;
      @media screen and (max-width: 374px) {
        font-size: 0.5rem;
        line-height: 0.6rem;
      }
    }
  }
  .time {
    width: 1.556rem;
    height: 0.63rem;
    margin: 0.398rem auto 0.833rem auto;
    border-radius: 0.315rem;
    border: solid 0.019rem #fff;
    background-color: #fff;
    font-size: 0.504rem;
    line-height: 0.63rem;
    letter-spacing: 0.05rem;
    color: #434142;
  }
  .option {
    width: 8rem;
    // min-height: 3.176rem;
    // max-height: 30%;
    height: 30%;
    @media screen and (max-height: 450px) {
      height: 20%;
    }
    overflow-y: auto;
    overflow-x: hidden;
    .vBarVisible {
      z-index: 0;
    }
    .el-radio-group {
      width: 100%;
      height: 100%;
      .el-radio {
        display: block;
        width: 96%;
        margin-top: 3px;
        min-height: 1.083rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        // &:nth-child(1) {
        //   background: url("../../assets/images/a.png") 0 0 / 0.963rem 1.083rem
        //     no-repeat;
        // }
        &:nth-child(n).is-checked {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 0.343rem;
        }
        .el-radio__input {
          display: none;
        }
        .el-radio__label {
          padding-right: 10px;
          font-size: 0.45rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 1rem;
          letter-spacing: 0.042rem;
          color: #fff;
          text-align: left;
          // margin-left: 1.444rem;
          text-align: left;
          display: block;
          height: auto;
          // width: 100%;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
          @media screen and (max-width: 374px) {
            font-size: 0.5rem;
          }
        }
      }
      .correct {
        background: rgba(255, 40, 70, 0.3);
        border-radius: 0.343rem;
      }
    }
  }
  .start {
    width: 2.778rem;
    height: 0.833rem;
    // margin: 0.954rem auto 0 auto;
    position: fixed;
    bottom: 12%;
    left: 50%;
    margin-left: -1.389rem;
  }
  .banner {
    width: 60%;
    height: auto;
    // margin: 0.5rem auto 0 auto;
    position: fixed;
    bottom: 4%;
    left: 10%;
    // margin-left: -0.278rem;
  }
  .close {
    width: 0.556rem;
    height: 0.556rem;
    // margin: 0.5rem auto 0 auto;
    position: fixed;
    bottom: 5%;
    left: 80%;
    // margin-left: -0.278rem;
  }
  .el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner {
    border-left-color: #512909;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/answer.vue